export enum TEXTFIELD_BUTTON_ACTION_TYPES {
  SEND = 1,
  GO_TO_MAPS = 2,
}
